import React, {useEffect, useState} from 'react';
import {Modal, Pagination, Popover, Input, Space, Button, message} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import {useInterval} from '../../../../../utils/extHooks';
import {timestampToTime} from '../../../../../utils/dateFormat';
import iconWarning from '../../../assets/images/icon_warning.png';
import iconClose from '../../../assets/images/icon_close_draw.png';
import {useStore} from '../../../stores';
import {checkPluginLoginRes, getThirdAuthJumpUrl, loginByPlugin, reportAuthStatus, getExternalAuthList, batchCheckLogin, batchCheckPluginLoginRes} from '../../../services/external';
import {JDLogo, meituanLogo, kuaishouLogo, logoMap, platformNameMap, platformTypeMap} from './config';
import './index.less';

export default props => {
    const store = useStore();
    const {externalStore = {}} = store;
    const [pageSize, setPagesize] = useState(5);
    const [pageIndex, setPageIndex] = useState(1);
    const [displayList, setDisplayList] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [pollingItem, setPollingItem] = useState(null);
    const [pollingTask, setPollingTask] = useState();

    const getData = async (needCheck = false) => {
        const res = await getExternalAuthList();

        if (res?.errno === 0 && res?.data) {
            const newList = Object.values(res.data.list).flat();
            externalStore.setAuthList(newList);

            // 进入页面在pop中会查询一次，中控台页面进入后再查，这里暂时不处理
            // needCheck && checkListPluginStatus(newList.filter(ele => ele.platform !== 5)); // 非京东平台 需要通过插件更新登录状态
        }
    };

    const checkListPluginStatus = async (list) => {
        if (!list || !list.length) {
            return;
        }

        const res = await batchCheckLogin(list);

        if (res?.code === 0 && res?.data) {
            setPollingTask(res.data.taskId);
        }
    };

    const onJump = val => {

        setPageIndex(Math.min(val, Math.ceil(externalStore.authList.length / pageSize)));
    };

    // 切换当前登录账号
    const onSwitch = item => {
        if (store.externalLiveInfo.id) {
            message.info('正在直播中，不可切换账号');
            return;
        }

        if (item.status === 1) {
            store.externalStore.setCurLoginAccount(item);
        }
        else {
            goAuth(item);
        }
    };

    const linkAuth = async (platform, third_id) => {
        const res = await getThirdAuthJumpUrl(platform, third_id);

        if (+res?.errno === 0 && res?.data?.jump_url) {
            message.info('正在跳转第三方授权页面，请稍候...');
            window.location.href = res.data.jump_url;
        }
    };

    const pluginAuth = async (item) => {
        const res = await loginByPlugin(platformTypeMap[item.platform]);

        if (res?.code === 0) {
            setPollingItem(item);
        }
    };

    const pollingAuthRes = async () => {
        const res = await checkPluginLoginRes(platformTypeMap[pollingItem.platform]).catch(e => {});

        if (res?.code === 0 && res?.data?.taskStatus !== 403) {
            setPollingItem(null);

            if (res?.data?.taskStatus === 0 && res?.data?.logginStatus === 1) {
                const {thirdPartyId, thirdPartyName, accountType} = res.data.user || {};

                const reportRes = await reportAuthStatus({
                    id: 0,
                    platform: pollingItem.platform,
                    status: 1,
                    open_id: thirdPartyId,
                    nick: thirdPartyName,
                    third_type: accountType,
                    avatar: ''
                }).catch(e => {});

                if (reportRes?.errno === 0) {
                    getData();
                }
            }
            else {
                message.warn('开启授权失败，请重试');
            }
        }
    };

    // 批量查询列表中账号对应状态并同步server
    const pollingBatchCheck = async () => {
        const res = await batchCheckPluginLoginRes(pollingTask).catch(e => {});

        if (res?.code === 0 && res?.data?.taskStatus !== 403) {
            setPollingTask();

            if (res?.data?.taskStatus === 0 && res?.data?.list.length) {
                const batchUpdateList = externalStore.authList.map(item => {
                    const curAccount = res.data.list.find(ele => ele.thirdPartyId === item.third_id);

                    if (curAccount) {
                        return reportAuthStatus({
                            id: item.id,
                            platform: item.platform,
                            status: curAccount.isLogin ? 1 : 3, // isLogin只有2个值，0为未授权 1为已授权
                            open_id: curAccount.thirdPartyId,
                            nick: curAccount.thirdPartyName,
                            third_type: curAccount.accountType,
                            avatar: ''
                        }).catch(e => {});
                    }
                }).filter(ele => !!ele);

                // 全部report后，重新获取列表
                Promise.all(batchUpdateList).finally(getData);
            }
            else {
                // safe，不阻塞主流程
            }
        }
        else {
            // safe，不阻塞主流程
        }
    };

    const goAuth = async (item) => {
        if (store.externalLiveInfo.id) {
            message.info('正在直播中，不可进行外部授权');
            return;
        }
        switch (item.platform) {
            case 2: // 快手
                if (!window.huibo_external_plugin_port) {
                    return;
                }
                pluginAuth(item);
                break;
            case 3: // 美团
                if (!window.huibo_external_plugin_port) {
                    return;
                }
                await pluginAuth(item);
                linkAuth(item.platform, item.third_id || '');
                break;
            case 5: // 京东
                linkAuth(item.platform, item.third_id || '');
                break;
            default:
                break;
        }
    };

    useInterval(pollingAuthRes, pollingItem ? 3000 : null);

    useInterval(pollingBatchCheck, pollingTask ? 3000 : null);

    useEffect(() => {
        setDisplayList(externalStore.authList.slice((pageIndex - 1) * pageSize, pageIndex * pageSize));
    }, [externalStore.authList, pageIndex]);

    useEffect(() => {
        setPageIndex(1);
        setDisplayList(externalStore.authList.slice(0, pageSize));
    }, [externalStore.authList, pageSize]);

    useEffect(() => {
        setIsShow(store.externalStore.showExternalModal);
    }, [store.externalStore.showExternalModal]);

    useEffect(() => {
        getData(true);
    }, []);

    const getModalFooter = () => {
        return (
            <Pagination
                className="ant-modal-footer-pagination"
                current={pageIndex}
                pageSize={pageSize}
                showSizeChanger={false}
                showQuickJumper={{goButton: true}}
                total={externalStore.authList.length}
                onChange={setPageIndex}
                locale={{
                    items_per_page: '条/页',
                    jump_to: '去第',
                    jump_to_confirm: '确定',
                    page: '页',
                    prev_page: '上一页',
                    next_page: '下一页',
                    prev_5: '向前 5 页',
                    next_5: '向后 5 页',
                    prev_3: '向前 3 页',
                    next_3: '向后 3 页'
                }}
            />
        );
    };

    if (!isShow) {
        return null;
    }

    return (
        <Modal
            visible
            className="huibo-external-auth-modal"
            title='外部账号授权'
            width={715}
            footer={getModalFooter()}
            closeIcon={<img src={iconClose} />}
            onCancel={() => store.externalStore.setShowExternalModal(false)}
        >
            <>
                {!window.huibo_external_plugin_port && (<div className="row auth-tips">
                    <img src={iconWarning} className="auth-tips-icon" />
                    <p>
                        部分账号授权状态获取失败，请
                        <a
                            className="auth-tips-link"
                            href="https://huibo-external.bj.bcebos.com/plugin_install.exe"
                            download="https://huibo-external.bj.bcebos.com/plugin_install.exe"
                        >下载插件</a>
                        以完成直播平台账号授权，若已安装完成，请激活插件。
                    </p>
                </div>)}
                <div className="row auth-platform">
                    新增授权账户：
                    <div className="row auth-platform-item" onClick={() => goAuth({platform: 5})}>
                        <img className="auth-platform-logo" src={JDLogo} /> 京东
                    </div>
                    {/* <div className={`row auth-platform-item ${window.huibo_external_plugin_port ? '' : 'disabled'}`} onClick={() => goAuth({platform: 3})}>
                        <img className="auth-platform-logo" src={meituanLogo} /> 美团
                    </div> */}
                    <div className={`row auth-platform-item ${window.huibo_external_plugin_port ? '' : 'disabled'}`} onClick={() => goAuth({platform: 2})}>
                        <img className="auth-platform-logo" src={kuaishouLogo} /> 快手
                    </div>
                </div>
                <div className="row auth-label">
                    <div className="auth-label-account">直播账户</div>
                    <div className="auth-label-platform">授权平台</div>
                    <div className="auth-label-status">直播状态</div>
                    <div className="auth-label-operation">操作</div>
                </div>
                <div className="auth-list">
                    {displayList.map((item, index) => {
                        const isCurLogin = store.externalStore.curLoginAccount?.third_id === item.third_id;

                        return (
                            <div key={index} className="row auth-list-item">
                                <div className="auth-list-item-account">
                                    <p>{item.third_nick || `${platformNameMap[item.platform]}账号`}</p>
                                    {isCurLogin && <div className="tag cur-login">当前登录</div>}
                                    {item.status === 3 && <div className="tag need-windows">请使⽤Windows开播</div>}
                                </div>
                                <div className="row auth-list-item-platform">
                                    <img src={logoMap[item.platform]} />
                                    {platformNameMap[item.platform]}
                                </div>
                                <div className="auth-list-item-status">
                                    {!!store.externalLiveInfo.id && store.externalLiveInfo.open_id === item.third_id
                                        && (
                                            <>
                                                <div className="row status-line">
                                                    <div className="status-circle green" />
                                                    直播中
                                                </div>
                                                <div className="status-desc">
                                                    开播时间：{timestampToTime(new Date(store.externalLiveInfo.ctime || '').getTime(), 2, 2)}
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                                <div className={`auth-list-item-operation status-${item.status}`} onClick={() => onSwitch(item)}>
                                    <p>{item.status === 1 ? '切换' : '重新授权后开播'}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        </Modal>
    );
};
